import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getExpressList() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/express`,
    method: 'get',
  });
}

export function getAllExpress() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/get-express-list`,
    method: 'get'
  })
}

export function updateCollectTime({ id, collectTime, collectDate, sendTime }) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/update-collect-time`,
    method: 'post',
    params: {
      id,
      collectTime,
      collectDate,
      sendTime
    }
  })
}

